import { Fragment } from "react";
import { TabPane } from "reactstrap";
import { useAppSelector } from "../../../../../reduxToolkit/hooks";
import SearchNotFoundClass from "../../../../../coreComponents/SearchNotFoundClass";
import InboxMailContent from "../inbox/InboxMailContent";

const Starred = () => {
  const { inboxEmail } = useAppSelector((state) => state.letterBox);
  let starBadges = inboxEmail.filter((data) => data.star === true && 1);

  return (
    <TabPane tabId="3">
      <div className="mail-body-wrapper">
        <ul>
          {starBadges.length > 0 ? (
            inboxEmail.map((data, i) => (
              <Fragment key={i}>
                {data.star && (
                  <li className="inbox-data">
                    <InboxMailContent data={data} ids={i} />
                  </li>
                )}
              </Fragment>
            ))
          ) : (
            <SearchNotFoundClass word="Email" />
          )}
        </ul>
      </div>
    </TabPane>
  );
};

export default Starred;